// 流入経路アトリビューション（GA4ファネルを流入経路/LP別に分析するため）
//
// 目的:
//   予約フローのファネルイベント(curenow_funnel)は LIFF(curenow.jp/medichat) 内で発火するが、
//   元の流入(広告LPのpath・utm)はLIFF起動URL(?path= / liff.state / saf_* / utm_*)にしか無い。
//   その値を「初回タッチ時点」で localStorage に保存し、後続セッションのファネルイベントにも
//   付与できるようにする。これにより GA4 のファネル内訳を entry_lp / entry_source 等で割れる。
//
// 設計:
//   - first-touch（最初に取得した値を維持。後から空で上書きしない）
//   - LIFFのリダイレクトで元URLが失われるため、App起動の最初期(render時)に capture を呼ぶ
//   - 値が取れない時は何もしない（既存の保存値を保持）

const STORAGE_KEY = 'curenow_entry_attribution';

function safeGetParams() {
  try {
    return new URLSearchParams(window.location.search);
  } catch (e) {
    return new URLSearchParams('');
  }
}

// liff.state（URLエンコードされた元のパス＋クエリ）から URLSearchParams と pathname を復元
function parseLiffState(params) {
  const liffState = params.get('liff.state');
  if (!liffState) return { stateParams: null, statePath: null };
  try {
    const decoded = decodeURIComponent(liffState);
    const statePath = new URL(decoded, window.location.origin).pathname;
    const stateParams = new URLSearchParams(decoded.split('?')[1] || '');
    return { stateParams, statePath };
  } catch (e) {
    return { stateParams: null, statePath: null };
  }
}

// 現在のURLから流入情報を抽出（取れたものだけ返す）
function parseFromUrl() {
  const out = {};
  try {
    const params = safeGetParams();
    const { stateParams, statePath } = parseLiffState(params);

    const pick = (...keys) => {
      for (const k of keys) {
        const v = params.get(k) || (stateParams && stateParams.get(k));
        if (v) return v;
      }
      return null;
    };

    // 流入LP（path）: liff.state のパス → ?path= → 現在のpathname の順
    let lp = statePath || pick('path') || window.location.pathname || null;
    if (lp && lp !== '/' && !lp.startsWith('/medichat')) {
      // /medichat 配下（アプリ内ルート）は流入LPではないので除外
      out.entry_lp = lp;
    }

    // 広告系（utm_* と、LP側で使われている saf_* の両対応）
    const source = pick('utm_source', 'saf_src');
    const medium = pick('utm_medium', 'saf_pt');
    const campaign = pick('utm_campaign', 'saf_cam');
    const ref = pick('ref');
    const entryState = pick('entry_state');

    if (source) out.entry_source = source;
    if (medium) out.entry_medium = medium;
    if (campaign) out.entry_campaign = campaign;
    if (ref) out.entry_ref = ref;
    if (entryState) out.entry_state = entryState;
  } catch (e) {
    // 解析失敗時は空を返す（計測のために本体機能を壊さない）
  }
  return out;
}

// 初回タッチ時の流入情報を localStorage に保存（App起動の最初期に1度呼ぶ）
export function captureEntryAttribution() {
  try {
    const fromUrl = parseFromUrl();
    if (!fromUrl || Object.keys(fromUrl).length === 0) return;

    let existing = {};
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      existing = raw ? JSON.parse(raw) : {};
    } catch (e) {
      existing = {};
    }

    // first-touch: 既存の値を優先（後から上書きしない）。欠けているキーのみ補完。
    const merged = { ...fromUrl, ...existing };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (e) {
    // localStorage不可（プライベートモード等）でも本体は動かす
  }
}

// 保存済みの流入情報を取得（ファネルイベントのpushに spread して使う）
export function getEntryAttribution() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
